import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import rehypeSlug from 'rehype-slug'
import {
  Article,
  DefaultPageLayout,
  HeadMetatags,
} from 'routes/components/Layout'
import { IntegrationType } from 'routes/Integrations/helpers/types'
import { IntegrationPageCommonWrapper } from '../components/IntegrationPageCommonWrapper'
import common from 'routes/Integrations/Integration/Integration.module.scss'

const rehypePlugins = [rehypeSlug, rehypeRaw]

export default function IntegrationGettingStartedPage({
  integration,
  readme,
}: {
  integration: IntegrationType
  readme: string
}) {
  if (!integration || !integration.key || !readme) {
    return <div>Loading...</div>
  }
  return (
    <DefaultPageLayout className={common.page}>
      <HeadMetatags
        title={`Getting Started - ${integration.name} Connector for Your Product`}
        description={`Add white-label customer-facing integration with ${integration.name} into your app with just a few lines of code.`}
        type={'article'}
        canonical={`/integrations/${encodeURIComponent(integration.key.toLowerCase())}`}
      />
      <IntegrationPageCommonWrapper integration={integration}>
        <Article.StyledTypography>
          <ReactMarkdown rehypePlugins={rehypePlugins}>{readme}</ReactMarkdown>
        </Article.StyledTypography>
      </IntegrationPageCommonWrapper>
    </DefaultPageLayout>
  )
}
